import React from 'react'

import { Form, Col } from '_zari/core'

import DocumentosSunatConstant from 'constants/tiposDeDocumentoSunat'

const TipoDocumentoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOCUMENTO' md={4} />
      <Col md={8}>
        <Form.InputText
          value={iValue ? DocumentosSunatConstant.__dictionary[iValue].nombre : '--'}
          id='input-tipoDocumento'
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
